let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("89rrl")).then(() => parcelRequire('3wO03'));